import i18next from 'i18next';
/**
 * @param language
 * @description This function changes the application language
 * on the basis of language {string}  passed to it
 */
export const changeAppLanguage = (language: string) => {
    i18next.changeLanguage(language.toLowerCase());
};
